import du from '../utils/dom-utilities';


/**
 * add height 100% from js-start (the inner div) to all the parents div
 * until js-end (the first child of the div with flex class).
 *
 * ^  _ div .jd-end
 * | |__ .height--full
 * | |___ .height--full
 * | |____ .height--full
 * | |_____ .height--full
 * | |______ div .js-start .height--full
 */
export default function heightBringer() {
    du.queryAll('.js-end').forEach((end) => {
        var start = end.querySelector('.js-start');
        if (start) {
                while (start !== end) {
                    start.classList.add('height--full');
                    start = start.parentNode;
                }
        }
    });
}



// WEBPACK FOOTER //
// ./src/main/js/components/heightBringer.js